import React from 'react'
import useObservable from 'front-end-core/hooks/useObservable'
import { requestSectionPrecedents } from 'services/PrecedentsService'
import NotFound from 'components/NotFound'
import Forbidden from 'components/shared/Forbidden'
import Icon from 'components/shared/Icon'
import { forEach, result } from 'libraries/lodash'
import DownloadButtonContainer from 'redux/containers/components/precedents/DownloadButtonContainer'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import { RESPONSE_PENDING } from 'front-end-core/constants/responses'

const getChildSectionTitle = (response, precedentId) => {
  const filteredParents = {}
  forEach(response.parents, (fileIds, parentId) => {
    filteredParents[parentId] = fileIds.filter(id => precedentId === id)
  })

  const childSections = result(response, 'childSections', [])
    .filter(id => result(filteredParents, id, []).length > 0)
    .map(id => response.nodes[id])

  return childSections.length > 0 ? childSections[0].title : null
}

const Description = ({ description }) => {
  const checkedDescription = description.replace(/(<([^>]+)>)/ig, '').length ? description : null

  return (
    <div
      className='min-h-spacing-9 ml8 bg-white precedents-description'
      dangerouslySetInnerHTML={{ __html: checkedDescription }}
    />
  )
}

const Preview = ({ title, name, description, sectionTitle, childSectionTitle, precedentId }) => (
  <div className='bg-white w-100'>
    <div className='bg-ghost-grey layout-width-constraint' style={{ minHeight: '43rem' }}>
      <div className='bg-white'>
        <div className='f3 b black pt7 pb6 ml6'>
          {sectionTitle}
        </div>
        {childSectionTitle &&
          <div className='bg-precedents-blue-exp white pv6 b pl6'>
            {childSectionTitle}
          </div>}
        <div className='pa6 pb5 bb b--precedents-blue'>
          <div className='b flex items-center justify-between'>
            <div className='flex items-center'>
              <div className='mr6 h-100'>
                <Icon className='vm w6' name='icon-file-document' />
              </div>
              <span>{title || name}</span>
            </div>
            <DownloadButtonContainer {...{ precedentId }} />
          </div>
          <Description {...{ description }} />
        </div>
      </div>
    </div>
  </div>
)

const PreviewResponseWrapper = ({ view, sectionId, precedentId, isLimitedAccess, aol }) => {
  const response = useObservable(requestSectionPrecedents(view === 'browse' ? 'precedents' : view, sectionId, aol), RESPONSE_PENDING)
  const ForbiddenOrNotFound = isLimitedAccess ? Forbidden : NotFound

  return (
    <ResponseConsumer
      response={response}
      notfoundComponent={ForbiddenOrNotFound}
      content={() => {
        const { files, sectionId } = response
        if (!files || !Object.prototype.hasOwnProperty.call(files, precedentId)) {
          return <ForbiddenOrNotFound />
        }

        const sectionTitle = result(response, ['nodes', sectionId, 'title'])
        const childSectionTitle = getChildSectionTitle(response, precedentId)
        const { title, name, description } = files[precedentId]

        return <Preview {...{ title, name, description, sectionTitle, childSectionTitle, precedentId }} />
      }}
    />
  )
}

export default PreviewResponseWrapper
